import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import configStore from './store/ConfigStore';
import App from './App';
import { Provider } from 'react-redux';
import moment from 'moment-timezone';

const initialState = (window as any).initialReduxState;
const store = configStore(initialState);

const container = document.getElementById('root');
const root = createRoot(container!);

moment.tz.setDefault('Europe/Copenhagen');

root.render(
    <Provider store={store}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <App />
        </BrowserRouter>
    </Provider>
);
